<template>
    <div v-if="show" class="mask">
      <div class="dlg-create-file flex flex-col">
        <div class="flex flex-space-between full-width">
          <div class="font-bold">创建文件</div>
          <div class="pointer" @click="close"><img class="logo-22" src="@/assets/images/guanbi.png"/></div>
        </div>
        <div class="margin-top-xl flex flex-col">
            <input class="input-box" placeholder="请输入文件名" v-model="inputValue" ref="getfocus"/>
            <SelectTag class="margin-top-l font-s" :data="docTypeData" v-model="docType"></SelectTag>

        </div>
        <div class="flex flex-end margin-top-xl">
          <div class="btn-huibai-auto pointer" style="width:80px" @click="cancelClick">取消</div>
          <div class="margin-left-m btn-blue-auto pointer" style="width:80px" @click="confirmClick">确定</div>
        </div>
      </div> 
    </div>
  </template>
   
  <script>

  import SelectTag from '../../components/selectTag/SelectTag.vue';
  
  
  export default {
      name: 'CreateFileConfirmModal',//组件递归必须有name属性 不然无法递归    
      components:{
        SelectTag
      },
      props: {
          value:{},
          show: {},
      },
      watch: {
        show(val){
            if (val == true) {
                this.$nextTick(() => {
                    this.$refs.getfocus.focus();
                })
            }
        },
        value(val){
          this.inputValue = val;
        }
  
      },
      data() {
          return {
            inputValue: "",
            docTypeData:[
                {id:"default",name:"普通文档"},
                {id:"test",name:"测试文档"},
                {id:"question",name:"试卷"}

            ],
            docType:"default"
          }
      },
      
      methods: {
       
          close() {
            this.show = false;  
          },
          open() {
            this.inputValue = "";
            this.docType = "default";
            this.show = true;
          },
          confirmClick() {
            if (this.inputValue == "") {
                this.$showToast({
                    msg: '文件名未填写',
                    duration: 2000
                })                              
            }  
            let result = {};
            result.name = this.inputValue;
            result.type = this.docType;
            this.$emit("confirm", result)
            
          },
          cancelClick() {     
            this.show = false;      
          }
  
      }
  }
  </script>
  
  <style scoped>
      .dlg-create-file {
          border-radius: 5px;
          width: 350px;
          height: 200px;
          background-color: #fff;
          padding: 30px;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
      }
  </style>
  


// WEBPACK FOOTER //
// src/views/modal/CreateFileConfirmModal.vue